async function postPaymentUsdt(paymentRepository, data) {
    return await paymentRepository.postPaymentUsdt(data)
}

async function postPaymentUsdtV8(paymentRepository, data) {
    return await paymentRepository.postPaymentUsdtV8(data)
}

export {postPaymentUsdt, postPaymentUsdtV8}